import { useCallback, useState } from "react";
import PhotoMarker from "../PhotoMarker/PhotoMarker";

const MapPhotoMarkers = ({ photoMarkers }) => {
  const [activeMarkerPhotoId, setActiveMarkerPhotoId] = useState(null);

  const onActivate = useCallback((id) => {
    setActiveMarkerPhotoId(id);
  }, []);

  if (photoMarkers?.length === 0) return null;

  return (
    <>
      {photoMarkers?.map((photo) => (
        <PhotoMarker
          data={photo}
          isActive={photo.id === activeMarkerPhotoId}
          onActivate={onActivate}
        />
      ))}
    </>
  );
};
export default MapPhotoMarkers;
